import { Link } from "react-router-dom";

const steps = [
  { title: "Submit Application", text: "Complete the online form with program preference, academic history, and a short motivation." },
  { title: "Review & Interview", text: "Admissions team reviews within 5 working days. Selected applicants may be invited for a short interview or portfolio review." },
  { title: "Offer & Fees", text: "Receive your offer letter with fee breakdown, payment schedule, and required documents." },
  { title: "Register & Onboard", text: "Secure your seat with the registration fee, attend orientation, and get access to learning platforms." },
];

const dates = [
  { label: "Applications open", value: "1 September 2026" },
  { label: "Early deadline", value: "31 October 2026" },
  { label: "Final deadline", value: "15 January 2027" },
  { label: "Orientation", value: "5 February 2027" },
  { label: "Application Fee", value: "R150 (non-refundable)" },
];

export default function AdmissionsPage() {
  return (
    <div className="page">
      <header className="page__hero">
        <h1>Admissions</h1>
        <p>Everything you need to know to apply, qualify, and join the next intake.</p>
      </header>

      <section className="section">
        <div className="section__inner">
          <div className="section__header">
            <span className="section__tag">Process</span>
            <h2 className="section__title">How to Apply</h2>
            <p className="section__subtitle">Clear, transparent steps from application to registration.</p>
          </div>
          <div className="admissions-flow">
            {steps.map((s, i) => (
              <div key={s.title} className="admissions-flow__step">
                <span className="admissions-flow__badge">{i + 1}</span>
                <div>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 32, display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/apply" className="btn btn--accent btn--lg">Start Your Application →</Link>
            <a
              href="/prospectors/MOKOROTLO CCT  BROCHURE 12.pdf"
              download="Mokorotlo_College_Prospectus.pdf"
              className="btn btn--outline btn--lg"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Prospectus
            </a>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="section__inner">
          <div className="section__header">
            <span className="section__tag">Entry Requirements</span>
            <h2 className="section__title">What You Need</h2>
            <p className="section__subtitle">Baseline academic and supporting documents for all programs.</p>
          </div>
          <div className="requirements-grid">
            <div className="requirements-card">
              <h3>Academic</h3>
              <ul>
                <li>Senior Certificate / Matric or equivalent</li>
                <li>Minimum pass in English</li>
                <li>Maths recommended for IT track</li>
              </ul>
            </div>
            <div className="requirements-card">
              <h3>Supporting Documents</h3>
              <ul>
                <li>Certified ID / passport copy</li>
                <li>Academic transcripts</li>
                <li>Proof of address</li>
                <li>Motivation letter (all programs)</li>
                <li>Proof of payment (R150 application fee)</li>
              </ul>
            </div>
            <div className="requirements-card">
              <h3>Portfolio (Optional)</h3>
              <ul>
                <li>Design: sketches, digital pieces, brand studies</li>
                <li>Film: short clips or storyboards</li>
                <li>IT: GitHub links or small projects</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section__inner">
          <div className="section__header">
            <span className="section__tag">Key Dates & Fees</span>
            <h2 className="section__title">Plan Ahead</h2>
            <p className="section__subtitle">
              Important milestones for the upcoming intake. Detailed fee schedules are provided in the offer letter.
            </p>
          </div>
          <div className="dates-grid">
            {dates.map((d) => (
              <div key={d.label} className="date-card">
                <p className="date-card__label">{d.label}</p>
                <p className="date-card__value">{d.value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
